import { render, staticRenderFns } from "./config029-f-rgbw.vue?vue&type=template&id=2eeafc4c&"
import script from "./config029-f-rgbw.vue?vue&type=script&lang=js&"
export * from "./config029-f-rgbw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports